import { render, staticRenderFns } from "./mac.vue?vue&type=template&id=a22d20a4"
import script from "./mac.vue?vue&type=script&lang=js"
export * from "./mac.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports